import { createContext, useContext } from "react";

/**
 * Optional toolbar slots the single review toolbar renders when the standalone
 * preview server is mounting the module.
 *
 * This context ships in the real bundle but its default is `null`, so inside
 * the shell (and any real build) the toolbar shows only the role pill, the run
 * select and Publish — none of these slots exist. The dev-only chrome (under
 * `dev/`, behind `__PREVIEW__`) is the only provider; it supplies the signed-in
 * fake user's name and a Log out handler so the toolbar can show the
 * "fake API" pill, the user name and Log out inline, rather than as a second
 * stacked strip. Deliberately named with no dev-only token so the real
 * build-output grep stays unambiguous.
 */
export interface ToolbarSlots {
  /** The signed-in fake user's display name. */
  userName: string;
  /** The preview pill text. Supplied by `dev/` so the label never ships in a locale. */
  pillLabel: string;
  /** Clears the fake session and returns to the sign-in chooser. */
  onLogOut: () => void;
}

export const ToolbarSlotsContext = createContext<ToolbarSlots | null>(null);

/** The optional toolbar slots, or `null` when not under the preview server. */
export function useToolbarSlots(): ToolbarSlots | null {
  return useContext(ToolbarSlotsContext);
}
